export default __webpack_public_path__ + "static/media/ScreenShot_1.c228b7b3.jpg";